import { loginConstants as lc } from 'srcReact/LoginPage'
import { alertActions } from 'srcReact/Alert'
import { organizationActions } from 'srcReact/OrganizationPage'
import { userService, organizationService, authenticationService, workplaceService } from 'srcReact/services'
import { cleanAllCookie, cleanData, getCookie, objectMap, setCookie } from 'srcReact/helpers/utils'
import { isEmpty, checkNested } from 'srcReact/helpers/validator'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import config from 'config'

export const loginActions = {
  login,
  loginWithWorkplace,
  //getCurrentUserProfile,
  //getCurrentUserProfileAndOrganization,
  userLogout,
  loginUser,
  // setPicture,
  setPictureDetails,
  checkEmail,
  setName
}

// function setPicture(picture) {
//   return { type: lc.LOGIN_SET_PICTURE, picture }
// }
function setPictureDetails(url, originalTag, isOriginal, mimeType) {
  return { type: lc.LOGIN_SET_PICTURE_URL, url, originalTag, isOriginal, mimeType }
}

function setName(firstname, lastname) {
  return { type: lc.SET_USER_NAME, firstname, lastname }
}

function login(email, password, orgId = 0, origin = '', keepLoggedIn, triggeredAction) {
  return (dispatch) => {
    dispatch(request({ email, triggeredAction }))
    userService.login(email, password, orgId, origin, keepLoggedIn, triggeredAction).then(
      (response) => {
        ///start - store cookie and localstorage after login
        if (isUserAuthorized()) {
          cleanAllCookie(['gdpr'])
          localStorage.clear()
        }
        if (getCookie('redirectUrlAfterAuth') != null) {
          setCookie('redirectUrlAfterAuth', '', -1)
        }
        if (origin !== 'sso' && orgId) {
          localStorage.setItem('mixrOrgId', orgId.toString())
        }
        localStorage.setItem('user', JSON.stringify(response.user))
        setCookie(
          appConstantSettings.LANG_COOKIE_NAME,
          response.user.language,
          appConstantSettings.LANG_COOKIE_EXP_DAYS
        )
        if (keepLoggedIn) {
          setCookie('usr_logged', 1, 365)
          setCookie('uaccess_token', response.access_token.access_token, 365)
        } else {
          setCookie('usr_logged', 1, 1)
          //  setCookie('uaccess_token', response.access_token.access_token, 1 / (24 * 60)) e.g. expiry date in seconds
          setCookie('uaccess_token', response.access_token.access_token, 1)
        }
        ///end - store cookie and localstorage after login
        dispatch(loginUser(response.user))
        dispatch(afterLogin(response.user, true, response.redirect_url, orgId, origin))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request(user) {
    return { type: lc.LOGIN_REQUEST, user }
  }
  function failure(error) {
    if (origin === 'sso') {
      localStorage.setItem('sso_error', error.toString())
      window.location = config.webUrl + '/auth'
    } else {
      return { type: lc.LOGIN_FAILURE, error }
    }
  }
}

function loginWithWorkplace(email, password, organizationId, workplaceIds) {
  return (dispatch) => {
    dispatch(request(email, organizationId, workplaceIds))

    userService.loginWithWorkplace(email, password, organizationId, workplaceIds).then(
      (response) => {
        ///start - store cookie and localstorage after login
        if (isUserAuthorized()) {
          cleanAllCookie(['gdpr'])
          localStorage.clear()
        }
        if (getCookie('redirectUrlAfterAuth') != null) {
          setCookie('redirectUrlAfterAuth', '', -1)
        }
        localStorage.setItem('user', JSON.stringify(response.user))
        setCookie(
          appConstantSettings.LANG_COOKIE_NAME,
          response.user.language,
          appConstantSettings.LANG_COOKIE_EXP_DAYS
        )

        setCookie('usr_logged', 1, 1)
        setCookie('uaccess_token', response.access_token, 1)
        ///end - store cookie and localstorage after login
        dispatch(loginUser(response.user))
        dispatch(afterLogin(response.user, true, response.redirect_url))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: lc.LOGIN_WITH_WP_REQUEST, response }
  }
  function success(response) {
    return { type: lc.LOGIN_WITH_WP_SUCCESS, response }
  }
  function failure(error) {
    return { type: lc.LOGIN_WITH_WP_FAILURE, error }
  }
}

function userLogout(email = '', password = '', orgId = 0) {
  return (dispatch) => {
    dispatch(request())

    userService.userLogout().then(
      (response) => {
        cleanData(true)
        if (email && password) {
          //this is called in case of SSO authentication
          dispatch(login(email, password, orgId, 'sso', false))
        } else {
          // window.location = `${config.webUrl}/communities-at-work`
          window.location = 'https://community.mixr.net/'
        }
      },
      (error) => {
        if (error.includes('HTTP_UNAUTHORIZED')) {
          cleanData(true)
          // window.location = `${config.webUrl}/communities-at-work`
          window.location = 'https://community.mixr.net/'
        } else {
          dispatch(failure(error))
        }
      }
    )
  }

  function request(response) {
    return { type: lc.LOGOUT_REQUEST, response }
  }
  // function success(response) {
  //   return { type: lc.LOGOUT_SUCCESS, response }
  // }
  function failure(error) {
    return { type: lc.LOGOUT_FAILURE, error }
  }
}

function loginUser(user) {
  return { type: lc.LOGIN_SUCCESS, user }
}

function afterLogin(user, redirect, redirectUrl, orgId, origin) {
  return (dispatch) => {
    organizationService.getByUser(appConstantSettings.ORG_LIST_QTY, 0, orgId, origin).then(
      async (response) => {
        let isInvited = false
        const list = response.list
          ? objectMap(
              response.list,
              (orga) => {
                return {
                  ...orga.info,
                  ...orga.organizations_basicsettings,
                  my_access: orga.organizations_my_access
                }
              },
              true
            )
          : []

        if (!isEmpty(list)) {
          localStorage.setItem('organization_list', JSON.stringify(list))
          dispatch(organizationActions.setCurrentOrganization(list[0], false))
        } else {
          isInvited = await workplaceService.getInvites(1).then((response) => {
            if (checkNested(response, 'list') && !isEmpty(response.list)) {
              return true
            }
            return false
          })
        }

        if (redirect) {
          if (user.valid_email == 0) {
            window.location = `${location.protocol}//${location.hostname}/account-not-validated`
          } else if (redirectUrl && redirectUrl != '') {
            window.location = redirectUrl
          } else if (isInvited) {
            window.location = `${location.protocol}//${location.hostname}/0/your-invites/`
          } else if (isEmpty(list)) {
            window.location = `${location.protocol}//${location.hostname}/0/create-or-join-workplace/`
          } else {
            window.location = `${location.protocol}//${location.hostname}/0/${appConstantSettings.DEFAULT_HOMEPAGE}`
          }
        } else {
          window.location.reload()
        }
      },
      (error) => {
        console.log('error:', error)
      }
    )
  }
}

function checkEmail(email) {
  return (dispatch) => {
    dispatch(request(email))

    authenticationService.checkEmail(email).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: lc.CHECK_EMAIL_REQUEST, response }
  }
  function success(response) {
    return { type: lc.CHECK_EMAIL_SUCCESS, response }
  }
  function failure(error) {
    return { type: lc.CHECK_EMAIL_FAILURE, error }
  }
}
